export default "__VITE_ASSET__BtPgTA2i__"